function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Created by liushuai on 2019-11-15
 *
 */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { NO_INVOICE_IMG } from '../constant';
import Topbar from './Topbar';
import Viewer from './Viewer';
import Navigation from './Navigation';

var ImageViewer = function ImageViewer(props) {
  var prefixCls = props.prefixCls,
      width = props.width,
      height = props.height,
      dataSource = props.dataSource,
      toolBarExtraContent = props.toolBarExtraContent;
  return React.createElement("div", {
    className: "".concat(prefixCls),
    style: {
      width: width,
      height: height
    }
  }, dataSource.length > 0 ? React.createElement(Content, props) : React.createElement(NoneBlock, null));
};

var Content = function Content(_ref) {
  var onChange = _ref.onChange,
      dataSource = _ref.dataSource,
      toolBarExtraContent = _ref.toolBarExtraContent;
  var viewerRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      key = _useState2[0],
      setKey = _useState2[1];

  var zoomHandle = useCallback(function (actionType) {
    if (viewerRef && viewerRef.current) {
      viewerRef.current.changeZoom(actionType);
    }
  }, [viewerRef.current]);
  var rotateHandle = useCallback(function (actionType) {
    if (viewerRef && viewerRef.current) {
      viewerRef.current.changeRotate(actionType);
    }
  }, [viewerRef.current]);
  var downloadHandle = useCallback(function () {
    if (viewerRef && viewerRef.current) {
      viewerRef.current.onDownload();
    }
  }, [viewerRef.current]);
  var switchHandle = useCallback(function (type, index) {
    var maxIndex = dataSource.length - 1; // 临界条件

    if (key <= 0 && type === 'prev' || key >= maxIndex && type === 'next') {
      return;
    }

    var newKey = 0;

    switch (type) {
      case 'prev':
        newKey = key - 1;
        break;

      case 'next':
        newKey = key + 1;
        break;

      default:
        newKey = index;
        break;
    }

    setKey(newKey);
    var code = dataSource[newKey] && dataSource[newKey].code;
    onChange(code);
  }, [onChange, key]);
  return React.createElement(React.Fragment, null, React.createElement(Topbar, {
    onZoom: zoomHandle,
    onRotate: rotateHandle,
    onDownload: downloadHandle,
    toolBarExtraContent: toolBarExtraContent
  }), React.createElement(Viewer, {
    img: dataSource[key],
    ref: viewerRef
  }), React.createElement(Navigation, {
    imgs: dataSource,
    selectKey: key,
    onSwitch: switchHandle
  }));
};

var NoneBlock = function NoneBlock() {
  return React.createElement("div", {
    className: "none-info"
  }, React.createElement("img", {
    src: NO_INVOICE_IMG,
    alt: "NO_INVOICE_IMG",
    className: "noInvoice-img"
  }), React.createElement("div", {
    className: "noInvoice-text"
  }, "\u6682\u65E0\u56FE\u7247"));
};

ImageViewer.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  dataSource: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  prefixCls: PropTypes.string,
  toolBarExtraContent: PropTypes.element
};
ImageViewer.defaultProps = {
  width: '100%',
  height: '100%',
  dataSource: [],
  onChange: function onChange() {},
  prefixCls: 'mkui-image-viewer'
};
export default ImageViewer;
//# sourceMappingURL=ImageViewer.js.map
